import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { Input } from "@/components/ui/input"
import type { BetterDocConsultationQuestionId } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-definition"
import { getQuestionTestIdPrefix } from "@/modules/patients/detail/better-doc/de/lib/better-doc-consultation-questionnaire-test-ids"
import type { DeBetterDocSearchFormType } from "@/modules/patients/detail/better-doc/de/schema/de-better-doc-search-schema"

export const BetterDocQuestionnaireTextField = ({ questionId }: { questionId: BetterDocConsultationQuestionId }) => {
  const { t } = useTranslation()
  const { control } = useFormContext<DeBetterDocSearchFormType>()

  return (
    <Controller
      control={control}
      name={questionId}
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => (
        <Input
          required
          label={t(`episodeOfCare.betterDoc.searchDialog.consultationQuestionnaire.${questionId}.label`)}
          value={value ?? ""}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onBlur}
          error={error?.message}
          translateError
          testId={getQuestionTestIdPrefix(questionId)}
        />
      )}
    />
  )
}
